<template>
  <v-content pa-0>
    <Header></Header>
    <div
        :style="$vuetify.breakpoint.mdAndUp ? { 'padding-top': '88px' } : {}"
        style="
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <v-img
          :src="
          $vuetify.breakpoint.smAndDown
            ? http + developerBanner.mobile_img
            : http + developerBanner.desktop_img
        "
          max-height="500px"
          style="width: 100%"
      ></v-img>
    </div>

    <loading :active.sync="isLoading"></loading>
    <div style="min-height: 80vh" class="mx-xl-15 px-xl-16 mx-lg-15 px-lg-16 mx-md-10 px-md-10 mx-sm-10 px-sm-10">
      <v-layout justify-center>
        <v-flex class="mt-15">
          <p style="font-size: 36px">
            <b>{{ $t("developer.data_sheet") }}</b>
          </p>
          <p style="font-size: 38px; color: #ff4f23">
            <b>
              <span v-if="language == 'th'">
                {{ dataDevContent.name_th }}
              </span>
              <span v-if="language == 'en'">
                {{ dataDevContent.name_en }}
              </span>
            </b>
          </p>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex class="mt-10 mx-10 text-left dev-data-text">
          <p style="font-size: 24px">
            <b>{{ $t("developer.data_overview") }}</b>
          </p>
          <v-row style="border: 1px black solid;">
            <v-col >
              <v-row>
                <v-col
                    class="dev-title"
                    cols="12"
                    lg="4"
                    md="4"
                    sm="4"
                    xl="2"
                    style=";background-color: #ebebeb;">
                <b style="text-align: right;white-space: nowrap" class="mx-3 dev-title">{{$t("developer.data_name") }}</b>
                </v-col>
                <v-col class="dev-title">
                  <span v-if="language == 'th'">
                     <b v-if="dataDevContent.name_th !=null">{{ dataDevContent.name_th }}</b>
                     <b v-else>-</b>
                  </span>
                  <span v-if="language == 'en'">
                     <b v-if="dataDevContent.name_en !=null">{{ dataDevContent.name_en }}</b>
                      <b v-else>-</b>
                  </span>
                </v-col>
              </v-row
              >
              <v-row
              >
                <v-col
                    cols="12"
                    lg="4"
                    md="4"
                    sm="4"
                    xl="2"
                    class="dev-title"
                   style="background-color: #ebebeb;">
                <b style="white-space: nowrap" class="mx-3 dev-title">{{$t("developer.description") }}</b>
                </v-col>
                <v-col class="dev-title">
                  <span v-if="language == 'th'">
                     <b v-if="dataDevContent.description_th !=null">{{ dataDevContent.description_th }}</b>
                     <b v-else>-</b>
                  </span>
                  <span v-if="language == 'en'">
                     <b v-if="dataDevContent.description_en !=null">{{ dataDevContent.description_en }}</b>
                      <b v-else>-</b>
                  </span>
                </v-col>
              </v-row
              >
              <v-row
              >
                <v-col
                    class="dev-title"
                    cols="12"
                    lg="4"
                    md="4"
                    sm="4"
                    xl="2"
                    style="background-color: #ebebeb;">
                  <b style="white-space: nowrap" class="mx-3 dev-title">{{$t("developer.reference") }}</b>
                </v-col>
                <v-col class="dev-title">
                  <span v-if="language == 'th'">
                     <b v-if="dataDevContent.reference_th !=null">{{ dataDevContent.reference_th }}</b>
                     <b v-else>-</b>
                  </span>
                  <span v-if="language == 'en'">
                     <b v-if="dataDevContent.reference_en !=null">{{ dataDevContent.reference_en }}</b>
                      <b v-else>-</b>
                  </span>
                </v-col>
              </v-row
              >
              <v-row
              >
                <v-col
                    cols="12"
                    lg="4"
                    md="4"
                    sm="4"
                    xl="2"
                    class="dev-title"
                    style="background-color: #ebebeb;">
                  <b style="white-space: nowrap" class="mx-3 dev-title">{{$t("developer.update_at") }}</b>
                </v-col>
                <v-col class="dev-title">
                     <b v-if="dataDevContent.data_import_date !=null">{{ dataDevContent.data_import_date | moment("DD/MM/YYYY") }}</b>
                     <b v-else>-</b>
                </v-col>
              </v-row
              >
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
      <div>
        <v-layout justify-center>
          <v-flex class="mt-7 mx-10 text-left dev-data-text">
                <b style="font-size: 24px;">{{ $t("developer.howto") }}</b>
              <v-col cols="12" lg="11" md="11" sm="11" xl="11" class="mt-0 pt-0  ml-0 pl-0">
                <span v-if="language == 'th' && dataDevContent.howto_th !=null">
                  <p>
                   &nbsp;&nbsp;&nbsp;&nbsp;{{ dataDevContent.howto_th }}
                  </p>
                </span>
                <span v-else-if="language == 'en' && dataDevContent.howto_en !=null">
                  <p>
                   &nbsp;&nbsp;&nbsp;&nbsp;{{ dataDevContent.howto_en }}
                  </p>
                </span>
                <span v-else>-</span>

              </v-col>
<!--            </v-row>-->
          </v-flex>
        </v-layout>

      </div>
      <div  v-if="dataDevContent.file_path || dataDevContent.file_path!= null" class="mt-5">
        <v-flex class="mx-xl-15 px-xl-16 mx-lg-15 px-lg-16 mx-md-10 px-md-10 mx-sm-10 px-sm-10 mx-5 mb-5 text-right">
          <a
              class="link-data-dev"
              style="font-size: 18px"
              @click="openFile(dataDevContent.file_path)"
          >
            <v-icon color="#FF4F23">{{ mdiArrowDownCircle }}
            </v-icon
            >
            <b> {{ $t("developer.downloadFile") }}</b></a
          >
        </v-flex>
        <v-simple-table class="mb-10 mx-xl-15 px-xl-16 mx-lg-15 px-lg-16 mx-md-10 px-md-10 mx-sm-10 px-sm-10" fixed-header style="width: auto">
          <thead>
          <tr>
            <!--                  <th class="text-center table-bg-color" style="color: #ff4f23;min-width: 400px">-->
            <!--                    <h1 style="padding-left: 5%">{{ $t("developer.data_sheet") }}</h1>-->
            <!--                  </th>-->
            <template v-for="(row,i) in dataDevContentExcel.data">
              <template v-for="(col, index) in row[0].length">
                <th class="text-center table-bg-color" style="color: #ff4f23;min-width: 210px" v-if="row[0][index] != null">
                  <p style="padding-left: 5%;font-size: 18px" class="my-3" >{{ row[0][index] }}</p>
                </th>
              </template>
            </template>
          </tr>
          </thead>
          <tbody>
          <template v-for="row in dataDevContentExcel.data">
            <template v-for="(col, i) in row">
              <template v-if="i >= 1">
                <tr>
                  <!--                        <td class="text-left pl-10">{{ [i] + '.' + ' ' + col[0] }}</td>-->
                  <template v-for="(item,index) in col" >
                    <!--                          <template v-if="index > 0">-->
                    <td  v-if="col[index] != null ">{{ col[index] }}</td>
                    <!--                    <td v-else-if=" col[index] == null || col[index] ==''">-</td>-->
                    <!--                          </template>-->
                  </template>
                </tr>

              </template>
            </template>
          </template>
          </tbody>
        </v-simple-table>
      </div>
    </div>



    <Footer></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Service from "../services";
import Loading from "vue-loading-overlay";
import {mapState} from "vuex";
import {domain} from "../services/Constants";
import {mdiArrowDownCircle} from "@mdi/js";

export default {
  name: "developerDetail",
  components: {
    Header,
    Footer,
    Loading,
  },
  data: () => ({
    mdiArrowDownCircle: mdiArrowDownCircle,
    loaded: false,
    http: domain,
    isLoading: false,
  }),
  computed: {
    ...mapState({
      language: (state) => state.locale.language,
      dataDevContent: (state) => state.DevData.dataDevContent,
      dataDevContentExcel: (state) => state.DevData.dataDevContentExcel,
      developerBanner: (state) => state.banner.developerBanner,
      industries: function (state) {
        return [
          {
            value: null,
            text: this.$i18n.t("general.select-industry"),
          },
          ...state.industry.industries.map((industry) => ({
            value: industry.id,
            text: industry[`name_${state.locale.language}`],
            icon_path: industry.icon_path,
          })),
        ];
      },
    }),
  },
  async created() {
    // Google analytic page view
    Service.analytics.sendPageView({
      path: this.$route.path,
    });
    await  this.clearData();
    await this.$store.dispatch("banner/onGetAllBanners");
    await this.getContent();
  },
  methods: {
    loadMore() {
      this.isLoading = true;
      setTimeout(() => {
        Service.webdata
            .getArticles({page: this.current_page + 1})
            .then((res) => {
              res.data.map((item) => {
                this.articles.push(item);
              });

              this.activeArticles = this.articles;
              if (this.articles.length < res.total) {
                this.current_page = res.current_page;
              } else {
                this.has_more = false;
              }
            });
        this.isLoading = false;
      }, 1000);
    },
    hrefTo(path) {
      this.$router.push(path);
    },
    async getContent() {
      let id = this.$route.params.id;
      await this.$store.dispatch("DevData/onGetDataDevContent", id);
      await this.$store.dispatch("DevData/onGetDataDevContentExcel", id);
    },
    async clearData(){
      await  this.$store.dispatch("DevData/clearState");
    },
    openFile(file_path) {
      // TODO: Preview excel
      window.open(this.http + "/" + file_path);
    },
  },
};
</script>

<style scoped>
.headTab {
  background: #000;
  color: #fff;
  text-transform: uppercase;
  font-size: 20px;
  display: flex;
  align-items: center;

}

.table-bg-color {
  color: #ff4f23 !important;
  background: black !important;
}

.link-data-dev {
  color: black;
}

.link-data-dev:hover {
  color: #ff4f23;
}

.dev-data-text {
  padding-left: 5%;
  padding-right: 5%;

}

.box-detail-col-1 {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.box-detail-col-2 {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.headIndex {
  font-size: 20px;
  font-weight: bold;
}

.tableTxt {
  font-size: 17px;
  color: #fff !important;
}

th.tdHead {
  background-color: #ff5100;
  font-size: 15px;
}

/* table border style */
.theme--light.v-data-table tbody tr td {
  border-bottom: 1px solid #ff5100 !important;
}

.theme--light.v-data-table thead tr th:nth-child(even):not(:first-child) {
  color: #ff5100 !important;
}

.theme--light.v-data-table tbody tr td:not(:last-child),
.theme--light.v-data-table thead tr:last-child th:not(:last-child) {
  border-right: 1px solid #ff5100;
}
.dev-title{
  padding-top: 3px!important;
  padding-bottom: 3px!important;
}
/*table, td {*/
/*  border: 2px solid black;*/
/*}*/
/*td{*/
/*  width: 50%;*/
/*}*/
/*table {*/
/*  width: 100%;*/
/*  border-collapse: collapse;*/
/*  border-radius: 15px;*/

/*}*/
/* end table border style */
</style>
